import * as types from '../../../lib/actionTypes.es6';

export function getRecentPaymentsRequest(payload) {
  return {
    type: types.GET_RECENT_PAYMENTS_REQUEST,
    payload: {
      ...payload,
      page: payload.page || 1,
      size: payload.size || 20,
    }
  };
}

export function getRecentPaymentsSuccess(payload) {
  return {
    type: types.GET_RECENT_PAYMENTS_SUCCESS,
    payload: payload,
  };
}

export function getRecentPaymentsFailure(error) {
  return {
    type: types.GET_RECENT_PAYMENTS_FAILURE,
    payload: error,
  };
}